import PageNav from "../components/PageNav";

export default function Login() {
	return (
		<h1>
			<PageNav />
			Login
		</h1>
	);
}
